import script from "./houseHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./houseHeader.vue?vue&type=script&setup=true&lang=js"

import "./houseHeader.vue?vue&type=style&index=0&id=16b542d4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16b542d4"]])

export default __exports__